import reservationApi, { UpdateRequest, CreateResponse } from '@api/reservation'
import { makeMutation } from '@lib/mutation'

export const useReservationUpdate = makeMutation<UpdateRequest, CreateResponse>({
  key: 'reservationUpdate',
  loader: async params => await reservationApi.update(params),
})
